const courseQuiz = {
  questions: [
    {
      question: 'How old are you?',
      answers: [
        { value: '14-17', text: '14-17' },
        { value: '18-24', text: '18-24' },
        { value: '25+', text: '25+' },
      ],
    },
    {
      question: "Are you looking to get your learner's permit or driver's license?",
      answers: [
        { value: 'permit', text: "Learner's Permit" },
        { value: 'license', text: "Driver's License" },
      ],
    },
    {
      question: "Do you already have a learner's permit?",
      answers: [
        { value: 'yes', text: 'Yes' },
        { value: 'no', text: 'No' },
      ],
    },
  ],
  currentQuestionIndex: 0,
  container: document.getElementById('quizQuestions'),
  backButton: document.getElementById('quizBackBtn'),
  footer: document.getElementById('quizFooter'),
  hasButtonsAdded: false,
  modal: new bootstrap.Modal(document.getElementById('courseQuizModal')),
  currentScreen: 'age', // This is used to determine the current screen
  cameFromLicensePath: false, // Track if we came from the license path
  licenseOptionSelected: null, // Track if we selected "Yes" or "No" from the license question
};

// Content templates
const contentTemplates = {
  adultDriverEd: {
    '18-24':
      "First-time drivers between the ages of 18 and 24 must complete 6 hours of driver education to obtain a driver's license. Our 100% online <strong>Adult Driver Education Course</strong> meets all state requirements and allows you to skip the written exam at the DPS!",
    '25+':
      "First-time drivers ages 25 and up are not required to take driver education to obtain a driver's license. However, it is highly recommended. Complete our 100% online <strong>Adult Driver Education Course</strong> to learn the basic rules of the road.",
  },
  permitOptions:
    "Our Parent-Taught and Self-Taught driver education courses meet all the education requirements to get your learner's permit and include the permit exam. The main difference is the behind-the-wheel training experience.",
  licenseWithPermit:
    "If you did not finish all 24 hours of driver education during the permit process, you'll need to complete those hours before applying for a driver's license (or provisional license). Our Parent-Taught and Self-Taught courses fulfill all education requirements and are 100% online.",
};

// Button templates
const buttonTemplates = {
  adultDriverEdButton: '<a id="adultDriverEdBtn" class="btn red btn-lg" href="/adult-driver-ed/">Learn More</a>',
  courseOptionsButtons: `
    <a id="parentTaughtBtn" class="btn blue btn-lg" href="#" data-value="parent-taught">Parent/Legal Guardian</a>
    <a id="selfTaughtBtn" class="btn blue btn-lg" href="#" data-value="self-taught">Licensed Instructor</a>
  `,
  courseNavigationButtons: {
    'parent-taught': '<a id="parent-taught-course-btn" class="btn red btn-lg" href="/teen-driver-ed/">Learn More</a>',
    'self-taught':
      '<a id="self-taught-course-btn" class="btn red btn-lg" href="/teen-driver-ed/texas-online-drivers-ed/">Learn More</a>',
  },
};

// Utility functions
const clearAllButtons = () => {
  const buttonContainers = courseQuiz.footer.querySelectorAll('p');
  buttonContainers.forEach((container) => {
    if (container.querySelector('a')) {
      container.remove();
    }
  });
  const allButtons = courseQuiz.footer.querySelectorAll('a');
  allButtons.forEach((button) => {
    // Only remove buttons that are not the back button
    if (!button.classList.contains('back-button') && button.id !== 'quizBackBtn') {
      button.remove();
    }
  });
  courseQuiz.hasButtonsAdded = false;
};

const addButtons = (buttonsHtml) => {
  courseQuiz.footer.insertAdjacentHTML('afterbegin', buttonsHtml);
  courseQuiz.hasButtonsAdded = true;
};

const attachListeners = (handler) => {
  courseQuiz.footer.querySelectorAll('a').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      courseQuiz.currentQuestionIndex++;
      handler(button.dataset.value);
    });
  });
};

// Question functions
const showAgeQuestion = () => {
  courseQuiz.container.innerHTML = `<h3 class="h4 fw-normal mb-0">${courseQuiz.questions[0].question}</h3>`;
  clearAllButtons();

  const buttonsHtml = `
    <p class="age-btn text-center mb-0">
      ${courseQuiz.questions[0].answers
        .map((answer) => `<a class="btn blue btn-lg m-2" href="#" data-value="${answer.value}">${answer.text}</a>`)
        .join('')}
    </p>
  `;
  addButtons(buttonsHtml);
  attachListeners(handleAgeSelection);
  toggleBackButton(false);
};

const showPermitLicenseQuestion = () => {
  courseQuiz.container.innerHTML = `<h3 class="h4 fw-normal mb-0">${courseQuiz.questions[1].question}</h3>`;
  clearAllButtons();

  const buttonsHtml = `
    <p class="permit-license-btn text-center mb-0">
      ${courseQuiz.questions[1].answers
        .map((answer) => `<a class="btn blue btn-lg m-2" href="#" data-value="${answer.value}">${answer.text}</a>`)
        .join('')}
    </p>
  `;
  addButtons(buttonsHtml);
  attachListeners(handlePermitLicenseSelection);
  toggleBackButton(true);
};

const showLicenseQuestion = () => {
  courseQuiz.container.innerHTML = `<h3 class="h4 fw-normal mb-0">${courseQuiz.questions[2].question}</h3>`;
  clearAllButtons();

  const buttonsHtml = `
    <p class="license-question-btn text-center mb-0">
      ${courseQuiz.questions[2].answers
        .map((answer) => `<a class="btn blue btn-lg m-2" href="#" data-value="${answer.value}">${answer.text}</a>`)
        .join('')}
    </p>
  `;
  addButtons(buttonsHtml);
  attachListeners(handleLicenseSelection);
  toggleBackButton(true);
};

const showAdultDriverEdContent = (ageGroup) => {
  courseQuiz.container.innerHTML = `${
    ageGroup === '18-24'
      ? '<p>You need: <strong>Adult Driver Education!</strong></p>'
      : '<p>We recommend: <strong>Adult Driver Education!</strong></p>'
  }
  <p class="mb-0">${contentTemplates.adultDriverEd[ageGroup]}</p>`;
  clearAllButtons();
  addButtons(buttonTemplates.adultDriverEdButton);
  toggleBackButton(true);
};

const showPermitOptionsContent = (includeIntro = false) => {
  const introText = includeIntro
    ? "<p>The first step to getting your driver's license is earning your learner's permit.</p>"
    : '';
  courseQuiz.container.innerHTML = `${introText}<p>${contentTemplates.permitOptions}</p>
  <p>Will you be completing your behind-the-wheel training with a parent or legal guardian or a licensed instructor at a driving school?</p>
  `;
  clearAllButtons();
  addButtons(buttonTemplates.courseOptionsButtons);
  attachListeners(handleCourseSelection);
  toggleBackButton(true);
};

const showLicenseWithPermitContent = () => {
  courseQuiz.container.innerHTML = `
    <p>${contentTemplates.licenseWithPermit}</p>
    <p><strong>To obtain your driver's license, you must meet the following requirements:</strong></p>
    <ul>
      <li>Be between 16 and 17 years old</li>
      <li>Hold a learner's permit for at least 6 months</li>
      <li>Complete 44 hours of behind-the-wheel training</li>
      <li>Complete the <a href="/impact-texas-drivers/">Impact Texas Teen Driver Program (ITTD)</a></li>
      <li>Pass a driving test and vision exam</li>
    </ul>
  `;
  clearAllButtons();
  toggleBackButton(true);
};

const showCourseDescription = (courseType) => {
  courseQuiz.container.innerHTML = `<p class="mb-0">You need: <strong>${
    courseType === 'parent-taught' ? 'Parent-Taught' : 'Self-Taught'
  } Driver Education!</strong></p>`;
  clearAllButtons();
  addButtons(buttonTemplates.courseNavigationButtons[courseType]);
  toggleBackButton(true);
};

// Update the selection handlers to track the current screen
const handleAgeSelection = (selectedAge) => {
  switch (selectedAge) {
    case '14-17':
      courseQuiz.currentScreen = 'permit-license';
      showPermitLicenseQuestion();
      break;
    case '18-24':
    case '25+':
      courseQuiz.currentScreen = 'adult-driver-ed';
      showAdultDriverEdContent(selectedAge);
      break;
  }
};

// Update the selection handlers to track the path
const handlePermitLicenseSelection = (selectedOption) => {
  switch (selectedOption) {
    case 'permit':
      courseQuiz.cameFromLicensePath = false; // We came from permit path
      courseQuiz.currentScreen = 'permit-options';
      showPermitOptionsContent(false);
      break;
    case 'license':
      courseQuiz.cameFromLicensePath = true; // We came from license path
      courseQuiz.currentScreen = 'license-question';
      showLicenseQuestion();
      break;
  }
};

const handleLicenseSelection = (selectedOption) => {
  courseQuiz.cameFromLicensePath = true;
  courseQuiz.licenseOptionSelected = selectedOption; // Track the selection
  switch (selectedOption) {
    case 'yes':
      courseQuiz.currentScreen = 'license-with-permit';
      showLicenseWithPermitContent();
      break;
    case 'no':
      courseQuiz.currentScreen = 'permit-options';
      showPermitOptionsContent(true);
      break;
  }
};

// Add this new function for the "No" case
const showPermitOptionsWithIntro = () => {
  courseQuiz.container.innerHTML = `
    <p>The first step to getting your driver's license is earning your learner's permit.</p>
    <p>${contentTemplates.permitOptions}</p>
  `;
  clearAllButtons();
  addButtons(buttonTemplates.courseOptionsButtons);
  attachListeners(handleCourseSelection);
  toggleBackButton(true);
};

const handleCourseSelection = (selectedCourse) => {
  courseQuiz.currentScreen = 'course-description';
  showCourseDescription(selectedCourse);
};

const toggleBackButton = (toggle) => {
  if (toggle === true) {
    if (!courseQuiz.backButton.classList.contains('d-none')) {
      return;
    }
    courseQuiz.backButton.classList.remove('d-none');
  } else {
    if (courseQuiz.backButton.classList.contains('d-none')) {
      return;
    }
    courseQuiz.backButton.classList.add('d-none');
  }
};

const handleBackButton = () => {
  if (courseQuiz.currentQuestionIndex === 0) {
    courseQuiz.modal.hide();
  } else {
    courseQuiz.currentQuestionIndex--;

    switch (courseQuiz.currentScreen) {
      case 'age':
        toggleBackButton(false);
        break;
      case 'permit-license':
        courseQuiz.currentScreen = 'age';
        showAgeQuestion();
        toggleBackButton(false);
        break;
      case 'license-question':
        courseQuiz.currentScreen = 'permit-license';
        showPermitLicenseQuestion();
        toggleBackButton(true);
        break;
      case 'permit-options':
        // Check which path we came from
        if (courseQuiz.cameFromLicensePath) {
          courseQuiz.currentScreen = 'license-question';
          showLicenseQuestion();
        } else {
          courseQuiz.currentScreen = 'permit-license';
          showPermitLicenseQuestion();
        }
        toggleBackButton(true);
        break;
      case 'license-with-permit':
        courseQuiz.currentScreen = 'license-question';
        showLicenseQuestion();
        toggleBackButton(true);
        break;
      case 'adult-driver-ed':
        courseQuiz.currentScreen = 'age';
        showAgeQuestion();
        toggleBackButton(false);
        break;
      case 'course-description':
        // Go back to the previous screen based on the license option selected
        if (courseQuiz.cameFromLicensePath) {
          if (courseQuiz.licenseOptionSelected === 'yes') {
            courseQuiz.currentScreen = 'license-with-permit';
            showLicenseWithPermitContent();
          } else {
            courseQuiz.currentScreen = 'permit-options';
            showPermitOptionsContent(courseQuiz.licenseOptionSelected === 'no');
          }
        } else {
          courseQuiz.currentScreen = 'permit-options';
          showPermitOptionsContent();
        }
        toggleBackButton(true);
        break;
    }
  }
};

// Initialize
const initializeQuiz = () => {
  showAgeQuestion();
  courseQuiz.backButton.addEventListener('click', (e) => {
    e.preventDefault();
    handleBackButton();
  });
};

initializeQuiz();
